export default {
  label: "position",
  valueScope:[
    'position-static',
    'position-relative',
    'position-absolute',
    'position-fixed',
    'position-sticky',
    'fixed-top',
    'fixed-bottom',
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/position.js